<template>
  <div>
    <div v-if="pairings.length > 0">
      Pairings:
      <div v-for="(pairing, idx) in pairings" :key="idx" class="p-1">
        <div v-if="!pairing.is_pairing_invalid" class="italic">
          <a
            class="text-purple hover:cursor-pointer"
            aria-label="see student detail page for this student"
            @click="showMentorModal(pairing.mentor_id)"
          >
            {{ pairing.mentor.prefix ? pairing.mentor.prefix : "" }}
            {{ pairing.mentor.firstname }} {{ pairing.mentor.lastname }}
          </a>
          -
          {{
            pairing.end_date
              ? convertToIOS(pairing.end_date).split(" ")[0]
              : "Current"
          }}
        </div>
      </div>
    </div>
    <div v-else>No pairings listed</div>
  </div>
</template>

<script>
import { convertToIOS } from "@/composables/date_utils";
export default {
  name: "StudentCardPairings",
  emits: ["showMentorModal"],
  props: {
    pairings: {
      type: Array,
      required: true,
    },
    mentorName: {
      type: Object,
      required: true,
    },
    mentorId: {
      type: String || Object,
      required: false,
      default: null,
    },
  },
  methods: {
    convertToIOS,
    showMentorModal(mentorId) {
      this.$emit("showMentorModal", mentorId);
    },
  },
};
</script>

<style scoped></style>
